// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { BusinessTypes } from '../Enums/BusinessTypes';
import { EstimateSaveRequest } from '../Classes/EstimateSaveRequest';
import { DocumentUploadModel } from '../Classes/DocumentUploadModel';
import { ForcePublishDetails } from '../Classes/ForcePublishDetails';
export class SapSubmittalRequest {
  bsetUserId: string;
  cultureId: number;
  salesPersonEmail: string;
  fileName: string;
  country: string;
  segmentId: number;
  precision: number;
  isProductPromotionEnabled: boolean;
  isCUIEstimate: boolean;
  showPPM: boolean;
  isQuotedServiceEstimate: boolean;
  userName: string;
  startDate: Date;
  endDate: Date;
  business: BusinessTypes;
  estimateSaveRequest: EstimateSaveRequest;
  costReviewDoc: DocumentUploadModel;
  sapSubmittalDoc: DocumentUploadModel;
  forcePublishDetails: ForcePublishDetails;
  partsAndSmartsHardwareComponent: number;
  partsAndSmartsConsultingLabor: number;
}
